import * as Location from 'expo-location';
import { Image } from 'react-native';

// true when running as an installed PWA (standalone window / home screen app) rather than in a browser tab
export function isInstalledPwa() {
    if (typeof window === 'undefined' || !window.matchMedia) {
        return false;
    }
    return (
        window.matchMedia('(display-mode: standalone)').matches ||
        window.matchMedia('(display-mode: fullscreen)').matches ||
        window.matchMedia('(display-mode: minimal-ui)').matches ||
        window.navigator.standalone === true // iOS Safari
    );
}

export function isIosDevice() {
    if (typeof navigator === 'undefined') {
        return false;
    }
    // iPadOS reports itself as a Mac, so also check for touch support
    return /iphone|ipad|ipod/i.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

// beforeinstallprompt can fire before any screen mounts, so capture it at module load
let deferredInstallPrompt = null;
const installListeners = new Set();
const notifyInstallListeners = () => installListeners.forEach((listener) => listener());

if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        deferredInstallPrompt = e;
        notifyInstallListeners();
    });
    window.addEventListener('appinstalled', () => {
        deferredInstallPrompt = null;
        notifyInstallListeners();
    });
}

// true when the browser can show its native install dialog (Chromium only; iOS has no such API)
export function canPromptInstall() {
    return deferredInstallPrompt !== null;
}

// returns 'accepted', 'dismissed', or null when no prompt is available
export async function promptInstall() {
    if (!deferredInstallPrompt) {
        return null;
    }
    const promptEvent = deferredInstallPrompt;
    // the event can only be used once
    deferredInstallPrompt = null;
    promptEvent.prompt();
    const choice = await promptEvent.userChoice;
    notifyInstallListeners();
    return choice.outcome;
}

// calls listener when install availability changes; returns an unsubscribe function
export function subscribeToInstallState(listener) {
    installListeners.add(listener);
    return () => installListeners.delete(listener);
}

// measures an image's natural size so it can be stored and reused for accurate display later
export function getImageDimensions(uri) {
    return new Promise((resolve) => {
        Image.getSize(
            uri,
            (width, height) => resolve({ width, height }),
            () => resolve({ width: null, height: null })
        );
    });
}

export function generateGuid() {
    //uuidv4
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

export async function getLocationPermissionStatus() {
    let { status } = await Location.getForegroundPermissionsAsync();
    return status;
}

export async function getLocation() {
    let { status } = await Location.requestForegroundPermissionsAsync();
    if (status !== 'granted') {
        // TODO: how to re-request
        //alert('Permission to access location was denied');
        //const test = Location.useForegroundPermissions();

        // console.log("status:", status);
        // console.log("requestPermission:", requestPermission);
        //alert('Please allow location access.');
        //window.location.href = "app-settings:location";
        return;
    }

    let location = await Location.getCurrentPositionAsync({});
    return location;
}

export async function getLocationMinneapolis() {
    
    //var location = new Location.LocationObject();
    //let location = await Location.getCurrentPositionAsync({});
    //let location = await Location.geocodeAsync("19 W 15th St, Minneapolis, MN", {});
    //let location = new Location.LocationData.LocationObject();
    //location.coords = new Location.LocationData.Coo();
    // location.coords.latitude = 44.9778;
    // location.coords.longitude = -93.2650;

    let location = {
        coords: { 
            latitude: 44.9778,
            longitude: -93.2650
        }
    }
    return location;
}

export function getDistanceFromLatLonInMiles(lat1, lon1, lat2, lon2) {
    //console.log("lat1, lon1, lat2, lon2", lat1, lon1, lat2, lon2);
    let distance = getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) * 0.621371;

    if (distance < 5)
        return distance.toFixed(1);
    else
        return distance.toFixed(0);
}

export function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var lat1 = toRad(lat1);
    var lat2 = toRad(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
}

// Converts numeric degrees to radians
function toRad(Value) 
{
    return Value * Math.PI / 180;
}

// export async function getLocationFromGoogle () {

//     const requestOptions = {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         //body: JSON.stringify({ postName: 'React updates ' })
//     };

//     try {
//         await fetch(
//             'https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBQmpsFNXkLFhuWyxeJMjUW-pk7O4xOHN4', requestOptions)
//             .then(response => {
//                 response.json()
//                     .then(data => {
//                         console.log("data:", data);
//                         return data;
//                     });
//             })
//     }
//     catch (error) {
//         console.error(error);
//     }
// }
//     return fetch('https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBQmpsFNXkLFhuWyxeJMjUW-pk7O4xOHN4', {
//         method: 'POST',
//         headers: {
//             Accept: 'application/json',
//             'Content-Type': 'application/json',
//         },

//     }).then(response => response.json())
// .then(json => {
//             return json;
//         })
//         .catch(error => {
//             console.error(error);
//         });
